import {OPTIMISTIC_KEY} from '@github-ui/optimistic-connection'

/**
 * Stable identity for a timeline row.
 */
export type TimelineItemIdentity = {readonly id: string; readonly [OPTIMISTIC_KEY]?: string}

export function timelineItemKey(item: TimelineItemIdentity): string {
  // The confirmed node carries a different, server-issued id, so keying off it would remount the
  // whole comment exactly as the write lands. The correlation key is stable across that swap.
  return item[OPTIMISTIC_KEY] ?? item.id
}
